import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { getTenantDisplayName } from '../tenantHelpers';

const ClearFaultModal = ({ tenant, isOpen, onClose, onConfirm, isSaving, error }) => {
  if (!isOpen || !tenant) return null;

  return (
    <div className="stm-modal-overlay" onClick={onClose}>
      <div className="stm-modal stm-modal--sm" onClick={(event) => event.stopPropagation()}>
        <header className="stm-modal__header">
          <div>
            <h2>Clear fault</h2>
            <p>{getTenantDisplayName(tenant)}</p>
          </div>
          <button type="button" className="stm-icon-btn" onClick={onClose} disabled={isSaving} aria-label="Close">
            <FaTimes />
          </button>
        </header>
        <div className="stm-modal__body">
          <p className="stm-modal__text">
            Clear fault for {getTenantDisplayName(tenant)}?
          </p>
          <p className="stm-modal__text stm-muted">
            The booking will be marked as no longer faulted and its booking end time will be set to now by the backend.
            This will make the tenant eligible for the normal cleanup process.
          </p>
          {error && <p className="stm-field-error">{error}</p>}
        </div>
        <footer className="stm-modal__footer">
          <button type="button" className="stm-btn stm-btn--secondary" onClick={onClose} disabled={isSaving}>Cancel</button>
          <button type="button" className="stm-btn stm-btn--primary" disabled={isSaving} onClick={onConfirm}>
            {isSaving ? 'Working...' : 'Clear Fault'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ClearFaultModal;
